import { useState } from "react";
import { Hand, Send, Mic } from "lucide-react";

const numberOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function CluePanel({ room, self, canClue, canReveal, isSpectator, onClue, onPass, busy }) {
  const [word, setWord] = useState("");
  const [number, setNumber] = useState(1);
  const [unlimited, setUnlimited] = useState(false);

  if (isSpectator) return null;
  if (!self.role) return null;

  const board = room.board;
  const isShared = room.mode === "shared";
  const voiceMode = room.options?.voice_mode || false;
  const inSuddenDeath = (board.sudden_death_teams || []).includes(board.turn);

  const submit = async (e) => {
    e.preventDefault();
    if (!voiceMode && !word.trim()) return;
    await onClue({
      word: voiceMode ? "" : word.trim(),
      number: unlimited ? 0 : Number(number),
      unlimited,
      voice: voiceMode,
    });
    setWord("");
    setNumber(1);
    setUnlimited(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 bg-[color:var(--surface)] border-t border-[color:var(--border)] shadow-[0_-12px_30px_rgba(0,0,0,0.5)]">
      <div className="max-w-2xl mx-auto px-3 py-3">
        {self.role === "spymaster" ? (
          inSuddenDeath ? (
            <div className="text-center label-classified" style={{ color: "var(--red)" }}>
              MUERTE SÚBITA · tu equipo no puede dar más pistas
            </div>
          ) : voiceMode ? (
            <div className="text-center" data-testid="voice-mode-spymaster-banner">
              <div className="label-classified inline-flex items-center gap-2 justify-center" style={{ color: "var(--amber)" }}>
                <Mic size={14} /> Modo voz
              </div>
              <div className="text-xs text-[color:var(--text-dim)] mt-1">
                {board.phase === "ended"
                  ? "Partida finalizada"
                  : isShared
                    ? "Da tu pista en voz alta — los agentes ya pueden tocar cartas"
                    : board.turn === self.team
                      ? "Da tu pista en voz alta — tus agentes ya pueden tocar"
                      : "Esperando al otro equipo…"}
              </div>
            </div>
          ) : canClue ? (
              <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 items-stretch" data-testid="clue-form">
                <input
                  data-testid="input-clue-word"
                  className="input-classified flex-1"
                  placeholder="PALABRA PISTA"
                  maxLength={30}
                  value={word}
                  onChange={(e) => setWord(e.target.value)}
                />
                <div className="flex gap-2">
                  <select
                    data-testid="select-clue-number"
                    className="input-classified sm:w-24"
                    value={number}
                    disabled={unlimited}
                    onChange={(e) => setNumber(e.target.value)}
                  >
                    {numberOptions.map((n) => (<option key={n} value={n}>{n}</option>))}
                  </select>
                  <label className="border-2 border-[color:var(--border)] px-3 flex items-center gap-2 cursor-pointer">
                    <input
                      data-testid="toggle-unlimited"
                      type="checkbox"
                      checked={unlimited}
                      onChange={(e) => setUnlimited(e.target.checked)}
                      className="accent-white"
                    />
                    <span className="label-classified">∞</span>
                  </label>
                </div>
                <button data-testid="btn-send-clue" type="submit" disabled={busy} className="btn-primary inline-flex items-center gap-2 justify-center">
                  <Send size={16} /> Enviar
                </button>
              </form>
          ) : (
            <div className="text-center label-classified">
              {board.phase === "ended" ? "Partida finalizada" :
                isShared ? "Esperando a los agentes…" :
                board.turn === self.team
                  ? "Esperando a que tus agentes adivinen…"
                  : "Esperando al otro equipo…"}
            </div>
          )
        ) : (
          canReveal ? (
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <div className="label-classified text-[color:var(--amber)]">
                Mantén pulsada una carta ~0,7s para revelarla
              </div>
              <button data-testid="btn-pass-turn" className="btn-ghost inline-flex items-center gap-2" onClick={onPass} disabled={busy}>
                <Hand size={14} /> Plantarse
              </button>
            </div>
          ) : (
            <div className="text-center label-classified">
              {board.phase === "ended"
                ? "Partida finalizada"
                : isShared ? "Esperando pista del Jefe…"
                : board.turn === self.team
                  ? "Esperando pista del Jefe…"
                  : "Esperando al otro equipo…"}
            </div>
          )
        )}
      </div>
    </div>
  );
}
